import api from '../api'

export default {
  async loadList (context) {
    api.customer.list().then((response) => {
      context.commit('listCommit', response)
    })
  }
}
